import React from 'react';
import { HeaderProps } from '../types';

const ShareScreenHeader: React.FC<HeaderProps> = ({
  onBackClick,
  isActionMode = true,
  actionTitle = 'Share Screen',
  ...context
}) => {
  return (
    <>
      {/* Back button */}
      <div className="mr-3 text-white flex items-center">
        <button
          onClick={onBackClick}
          className="p-2 rounded-lg transition-colors cursor-pointer"
          title="Back to search"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </button>
      </div>

      {/* Title */}
      <div className="flex-1 flex items-center">
        <h2 className="text-white text-base sm:text-sm font-medium leading-none">
          {actionTitle}
        </h2>
      </div>

      {/* Share button */}
      <div className="pr-3">
        <button
          onClick={() => {
            // In a real app, this would start screen sharing
            console.log('Share screen clicked');
            alert('Share screen functionality would be implemented here');
          }}
          className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
        >
          Share
        </button>
      </div>
    </>
  );
};

export { ShareScreenHeader };
